import { render, staticRenderFns } from "./PlaceScreens.vue?vue&type=template&id=18230870&"
import script from "./PlaceScreens.vue?vue&type=script&lang=js&"
export * from "./PlaceScreens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports